export type CMSComponentType = 'ROUTE' | 'KEYWORD' | 'INTEGRATION';

export interface CMSConditions {
    channelId: number;
    size: string;
    field: string;
    type: string;
    header?: string;
}

export interface CMSMetaData {
    contentId: string;
    size: string;
}

export interface CMSLinkData {
    contentText: string;
    linkUrl?: string;
    linkText?: string;
    size?: string;
}

export interface displayMoreInfo {
        description: string;
        limitAndExample: string;
        name: string;
        previewImage: previewImage
    }

export interface previewImage {
        id: string;
        linkType: string;
        type: string;
    }
